








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { EmploymentStatusDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxEmploymentStatus extends Vue {
  private types: EmploymentStatusDto[] | null = [];
  public selectedType = new EmploymentStatusDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: EmploymentStatusDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: EmploymentStatusDto) {
    this.$emit("employmentStatusSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .employmentStatus_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
